export interface IOption {
  value: any;
  label: string;
}
interface IOptionStore {
  [key: string]: any;
}
export const rewardTypeOptions: IOption[] = [
  {
    value: 0,
    label: 'paymentOptions.nothing', // '无'
  },
  {
    value: 1,
    label: 'paymentOptions.superposition', // '叠加'
  },
  {
    value: 2,
    label: 'paymentOptions.increaseRevenue', // '增加公司收益'
  },
  {
    value: 3,
    label: 'paymentOptions.savingManpower', // '可节约人力'
  },
  {
    value: 4,
    label: 'paymentOptions.costSaving', // '可节省成本'
  },
];
export const usageTimesOptions: IOption[] = [
  {
    value: -1,
    label: 'paymentOptions.notSelected', // '未选择'
  },
  {
    value: 1,
    label: 'paymentOptions.lessThanOrEqualToTwiceAYear', // '一年少于等于2次'
  },
  {
    value: 2,
    label: 'paymentOptions.lessThanOrEqualTo5TimesAYear', // '一年少于等于5次'
  },
  {
    value: 3,
    label: 'paymentOptions.lessThanOrEqualTo10TimesAYear', // '一年少于等于10次'
  },
  {
    value: 4,
    label: 'paymentOptions.lessThanOrEqualTo11TimesAYear', // '一年少于等于11次'
  },
  {
    value: 5,
    label: 'paymentOptions.AMonthTo1_3Times', // '每月1~3次'
  },
  {
    value: 6,
    label: 'paymentOptions.AWeekTo1_3Times', // '每周1~3次'
  },
  {
    value: 7,
    label: 'paymentOptions.AWeekTo4_5Times', // '每周4~5次'
  },
  {
    value: 8,
    label: 'paymentOptions.ADayTo1_3Times', // '每天1~3次'
  },
  {
    value: 9,
    label: 'paymentOptions.MoreThan3TimesADay', // '每天3次以上'
  },
];
export const saveTimeOptions: IOption[] = [
  {
    value: -1,
    label: 'paymentOptions.notSelected', // '未选择'
  },
  {
    value: 1,
    label: 'paymentOptions.within1Minute', // '1 分钟之内'
  },
  {
    value: 2,
    label: 'paymentOptions.minute1_30', // '1~30分钟'
  },
  {
    value: 3,
    label: 'paymentOptions.minute30_60', // '30~60分钟'
  },
  {
    value: 4,
    label: 'paymentOptions.minute60_90', // '60~90分钟'
  },
  {
    value: 5,
    label: 'paymentOptions.minute90_120', // '90~120分钟'
  },
  {
    value: 6,
    label: 'paymentOptions.minute120_150', // '120~150分钟'
  },
  {
    value: 7,
    label: 'paymentOptions.minute150_180', // '150~180分钟'
  },
  {
    value: 8,
    label: 'paymentOptions.moreThan180minute', // '180分钟以上'
  },
];
export const affectDepCountOptions: IOption[] = [
  {
    value: -1,
    label: 'paymentOptions.notSelected', // 未选择
  },
  {
    value: 2,
    label: 'paymentOptions.department1', // '1个部门'
  },
  {
    value: 3,
    label: 'paymentOptions.departments2_3', // '2~3个部门'
  },
  {
    value: 4,
    label: 'paymentOptions.departments4_6', // '4~6个部门'
  },
  {
    value: 5,
    label: 'paymentOptions.departments6_8', // '6~8个部门'
  },
  {
    value: 6,
    label: 'paymentOptions.MoreThan8Departments', // '8个部门以上'
  },
];
export const peopleCountOptions: IOption[] = [
  {
    value: -1,
    label: 'paymentOptions.notSelected', // '未选择'
  },
  {
    value: 2,
    label: 'paymentOptions.person1', // '1人'
  },
  {
    value: 3,
    label: 'paymentOptions.person2_5', // '2~5人'
  },
  {
    value: 4,
    label: 'paymentOptions.person6_10', // '6~10人'
  },
  {
    value: 5,
    label: 'paymentOptions.person11_15', // '11~15人'
  },
  {
    value: 6,
    label: 'paymentOptions.person16_25', // '16~25人'
  },
  {
    value: 7,
    label: 'paymentOptions.person26_35', // '26~35人'
  },
  {
    value: 8,
    label: 'paymentOptions.MoreThan35Person', // '35人以上'
  },
];
const rewardTypeStore: IOptionStore = {};
const usageTimesStore: IOptionStore = {};
const saveTimeStore: IOptionStore = {};
const affectDepCountStore: IOptionStore = {};
const peopleCountStore: IOptionStore = {};

const getLabelByValue = (key: number, store: IOptionStore, options: IOption[]) => {
  if (store[key]) {
    return store[key];
  } else {
    const result = options.find((option) => option.value === key);
    store[key] = result ? result.label : '';
    return store[key];
  }
};
export const getRewardTypeByValue = (key: number) => {
  return getLabelByValue(key, rewardTypeStore, rewardTypeOptions);
};
export const getUsageTimesByValue = (key: number) => {
  return getLabelByValue(key, usageTimesStore, usageTimesOptions);
};
export const getSaveTimeByValue = (key: number) => {
  return getLabelByValue(key, saveTimeStore, saveTimeOptions);
};
export const getAffectDepCountByValue = (key: number) => {
  return getLabelByValue(key, affectDepCountStore, affectDepCountOptions);
};
export const getPeopleCountByValue = (key: number) => {
  return getLabelByValue(key, peopleCountStore, peopleCountOptions);
};
